import request from '@/utils/request'

// 查询评价管理列表
export function listReview(query) {
  return request({
    url: '/order/review/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询评价管理分页
export function pageReview(query) {
  return request({
    url: '/order/review/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询评价统计
export function statisticsReview(query) {
  return request({
    url: '/order/review/statistics',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 回复评价
export function replyReview(data) {
  return request({
    url: '/order/review/reply',
    method: 'post',
    data: data
  })
}

// 查询评价管理详细
export function getReview(data) {
  return request({
    url: '/order/review/detail',
    method: 'get',
    params: data
  })
}

// 新增评价管理
export function addReview(data) {
  return request({
    url: '/order/review/add',
    method: 'post',
    data: data
  })
}

// 修改评价管理
export function updateReview(data) {
  return request({
    url: '/order/review/edit',
    method: 'post',
    data: data
  })
}

// 删除评价管理
export function delReview(data) {
  return request({
    url: '/order/review/delete',
    method: 'post',
    data: data
  })
}
